export default {
  state: {
    notices: getNoticesFromLocalStorage()
  },
  mutations: {
    addNotice({ notices }, payload) {
      const length = notices.length;

      const notice = { ...noticeFactory(), ...payload };

      if (!notice.message) return;

      if (length > 1) {
        if (notices[length - 1].message === notice.message) {
          return;
        }
      }

      notices.push(notice);

      saveNoticesToLocalStorage(notices);
    },
    clearNotices(state) {
      state.notices = [];
    }
  },
  getters: {
    getNotices(state) {
      return state.notices;
    }
  },
  actions: {
    shiftNotices({ state }) {
      const shiftedNotice = state.notices.shift();
      saveNoticesToLocalStorage(state.notices);
      return shiftedNotice;
    }
  }
};

function noticeFactory(isError) {
  return {
    message: null,
    type: isError ? "error" : "alert",
    timeout: 3000
  };
}

function getNoticesFromLocalStorage() {
  const notices = JSON.parse(localStorage.getItem("notifications"));
  return notices ? notices : [];
}

function saveNoticesToLocalStorage(notices) {
  localStorage.setItem("notifications", JSON.stringify(notices));
}
